import { useEffect, useState, useRef } from 'react';
import { useNavigate, Link } from "react-router-dom";
import clientInformation from '../login/ClientInfo';
import Alerts from '../helpers/Alerts';
import { IsValidToken, VerificationId, GetCustomerInfo, GetProfileInfo } from "../../services/AuthenticationService";
import { GetPayoutsLimits } from "../../services/PayoutService";
import { GetExpressLimits } from "../../services/DepositService";
import Loading from '../helpers/Loader';

export const PayoutMethods = () => {
    const clientInfo = clientInformation();
    let MAXLIMIT = process.env.REACT_APP_MaxLimit;
    const [isLoading, setIsLoading] = useState(true);
    const [arrayPayouts, setArrayPayouts] = useState([]);
    const [disableExpress, setDisableExpress] = useState(false);
    const navigate = useNavigate();
    let HideNavigation = process.env.REACT_APP_HideNavigation;
    const [isCheckingVerification, setIsCheckingVerification] = useState(false);//Id Verification
    const pollingIntervalRef = useRef(null);//Id Verification
    const pollCountRef = useRef(0);//Id Verification
    const MAX_POLL_ATTEMPTS = 60; // 60 intentos = 5 minutos (cada 5 segundos)//Id Verification
    const [shouldReloadData, setShouldReloadData] = useState(false);

    useEffect(() => {

        IsValidToken(localStorage.getItem('Token')).then(async function (response) {
            const customerInfoResponse = await GetCustomerInfo(localStorage.getItem('Token'));//Id Verification   
            const customerID = customerInfoResponse?.Authentication?.CustomerID;
            const onFile = customerInfoResponse?.Authentication?.OnFile;
            const email = customerInfoResponse?.Authentication?.Email;
            const profileInfoResponse = await GetProfileInfo(customerID);
            const IDVerification = profileInfoResponse?.Authentication?.bIDVerification ?? true;

            clientInfo.funcMapCustomer(customerInfoResponse);

            if (IDVerification === true || IDVerification === "true") {//Id Verification
                if (onFile === false || onFile === "false") {
                    await startVerificationID(email, customerID);
                    return;
                }
            }
            await PayoutsLimits();
            await ExpressDepositsLimits();
        }

        ).catch(function (error) {
            navigate('/expired/');
        })

        // Cleanup polling 
        return () => {
            stopPolling();//Id Verification
        };

    }, [shouldReloadData]);

    //===========================
    //ID VERIFICATION
    //===========================

    const stopPolling = () => {
        if (pollingIntervalRef.current) {
            clearInterval(pollingIntervalRef.current);
            pollingIntervalRef.current = null;
        }
        pollCountRef.current = 0;
    };

    const startVerificationID = async (email, customerID) => {
        try {
            if (!email || !customerID) {
                Alerts.ShowAlert(
                    "Error",
                    "Customer information is missing. Please try again.",
                    "error"
                );
                setIsLoading(false);
                return;
            }

            const data = {
                "Email": email,
                "CustomerID": customerID
            };

            const VerificationResult = await VerificationId(data);

            const list = VerificationResult?.Authentication?.ResultList;

            if (!list || !Array.isArray(list) || list.length === 0) {

                Alerts.ShowAlert(
                    "Error",
                    "Invalid verification response.",
                    "error"
                );
                setIsLoading(false);
                return;
            }

            const parsed = {};
            list.forEach(item => {
                if (item?.Element && item?.ErrorDescription) {
                    parsed[item.Element] = item.ErrorDescription;
                }
            });

            const verificationUrl = parsed.verification_source;

            if (!verificationUrl) {
                Alerts.ShowAlert(
                    "Error",
                    "Verification URL not found.",
                    "error"
                );
                setIsLoading(false);
                return;
            }

            try {
                new URL(verificationUrl); 
            } catch (urlError) {
                Alerts.ShowAlert(
                    "Error",
                    "Invalid verification URL format.",
                    "error"
                );
                setIsLoading(false);
                return;
            }

            setIsLoading(false);

            setTimeout(() => {
                Alerts.VerificationID(verificationUrl, () => {
                    startPollingVerification();
                });
            }, 100);

        } catch (error) {
            Alerts.ShowAlert(
                "Error",
                "Error starting verification: " + (error.message || error),
                "error"
            );
            setIsLoading(false);
        }
    };
    const checkVerificationStatus = async () => {
        try {
            const response = await GetCustomerInfo(localStorage.getItem('Token'));
            clientInfo.funcMapCustomer(response);
            
            if (response?.Authentication?.OnFile === true || response?.Authentication?.OnFile === "true") {
                // Stop polling
                if (pollingIntervalRef.current) {
                    clearInterval(pollingIntervalRef.current);
                    pollingIntervalRef.current = null;
                }

                setIsCheckingVerification(true);

                Alerts.ShowAlert(
                    "Success",
                    "Verification completed successfully! Loading redemption options...",
                    "success"
                );

                // Reload page
                setTimeout(() => {
                    setShouldReloadData(prev => !prev);
                }, 2000);

                return true;
            }

            return false;
        } catch (error) {
            console.error("Error checking verification status:", error);
            return false;
        }
    };

    const startPollingVerification = () => {
        setIsCheckingVerification(false);
        pollCountRef.current = 0;

        Alerts.ShowAlert(
            "Info",
            "No options are available until the verification is complete.",
            "info"
        );

        checkVerificationStatus();

        // Start polling
        pollingIntervalRef.current = setInterval(async () => {
            pollCountRef.current++;

            const completed = await checkVerificationStatus();

            if (completed || pollCountRef.current >= MAX_POLL_ATTEMPTS) {
                if (pollingIntervalRef.current) {
                    clearInterval(pollingIntervalRef.current);
                    pollingIntervalRef.current = null;
                }

                if (!completed && pollCountRef.current >= MAX_POLL_ATTEMPTS) {
                    setIsCheckingVerification(true);
                    Alerts.ShowAlert(
                        "Info",
                        "No options are available until the verification is complete.",
                        "info"
                    );
                }
            }
        }, 5000); // 5 seconds
    };

    //===========================
    //ID VERIFICATION
    //===========================

    async function ExpressDepositsLimits() {
        await GetExpressLimits(localStorage.getItem('Token')).then(async function (response) {
            if (response.Authentication.length === 0) {
                setDisableExpress(true);
            }
        });
    }

    async function PayoutsLimits() {
        await GetPayoutsLimits(localStorage.getItem('Token'), clientInfo.CurrencyCode, clientInfo.AvailableBalance).then(async function (response) {
            
            var i = 0;
            const filtered = response.Authentication.map(item => {

                const {
                    IconURL,
                    ImageName,
                    MaxPayout,
                    MinPayout,
                    PaymentType,
                    PayoutID,
                    PayoutName,
                    ProcessorID
                } = item;
                if (item.PaymentType.toLowerCase() === "credit card" ||
                    item.PaymentType.toLowerCase() === "crypto" ||
                    item.PaymentType.toLowerCase() === "check" ||
                    item.PaymentType.toLowerCase() === "money gram" ||
                    item.PaymentType.toLowerCase() === "generic" ||
                    item.ImageName.toLowerCase() === 'aeropay' ||
                    item.ImageName.toLowerCase() === 'cfrtp' ||
                    item.ImageName.toLowerCase() === 'coinflow'
                ) {
                    return {
                        Key: i++,
                        IconURL,
                        ImageName,
                        MaxPayout,
                        MinPayout,
                        PaymentType,
                        PayoutID,
                        PayoutName,
                        ProcessorID
                    };
                }
            });
            await setArrayPayouts(filtered.filter(function (element) { return element !== undefined; }));
            setIsLoading(false);
            await localStorage.setItem('arrayPayoutsMethods', JSON.stringify(filtered.filter(function (element) { return element !== undefined; })));
        }).catch(function (error) {
            setIsLoading(false);
            clientInfo.Error = false;
            Alerts.ShowAlert('Error', 'Error getting payout limits info: ' + error.response.data.Authentication.ErrorDescription, 'error');


        })
    }
    
    function GetFormURL(Key) {
        if (arrayPayouts[Key].PaymentType.toLowerCase() === "credit card")
            return "/payouts/creditcard/"
        else if (arrayPayouts[Key].PaymentType.toLowerCase() === "crypto")
            return "/payouts/crypto/" + arrayPayouts[Key].PayoutID
        else if (arrayPayouts[Key].PaymentType.toLowerCase() === "money gram")
            return "/payouts/moneygram/"
        else if (arrayPayouts[Key].PaymentType.toLowerCase() === "check")
            return "/payouts/check/" + arrayPayouts[Key].PayoutID
        else if (arrayPayouts[Key].PaymentType.toLowerCase() === "generic") 
            return "/payouts/generic/" + arrayPayouts[Key].ProcessorID
        else if (arrayPayouts[Key].ImageName.toLowerCase() === "aeropay") 
            return "/payouts/aeropay/" + arrayPayouts[Key].PayoutID
        else if (arrayPayouts[Key].ImageName.toLowerCase() == "coinflow")
            return "/payouts/coinflow/" + arrayPayouts[Key].PayoutID
        else if (arrayPayouts[Key].ImageName.toLowerCase() == "cfrtp")
            return "/payouts/rtp/" + arrayPayouts[Key].PayoutID
        else
            return "";
    }

    if (isLoading) {
        return <Loading />;
    }

    const handleMethodSelect = (name) => {
        navigate(`/deposits/${name}`);
    }

    const handleExpressSelect = () => {
        navigate(`/main/`);
    }

    return (
        <div className="mt-3 componentload">
            <div className="title">
                <div className="container">
                    <h4 className="txt-primary payout-title-color mb-4">Payout methods</h4>
                </div>
            </div>
            <div className="row" style={{ display: 'none' }}>
                {HideNavigation == 'true' ? <div></div> :
                    (disableExpress == false) ?
                        <div className="col-xxl-6 col-md-6 col-sm-6 col-xs-6">
                            <div onClick={() => handleExpressSelect()} className="box-deposit express-color mb-4 text-center text-wrap" >
                                <span className="othermethod-text text-center">EXPRESS DEPOSIT</span>
                            </div>
                        </div>
                        :
                        <div className="col-xxl-6 col-md-6 col-sm-6 col-xs-6" title="You need to deposit first to have this option available">
                            <div className="box-deposit express-color-disabled mb-4 text-center text-wrap" >
                                <span className="othermethod-text text-center">EXPRESS DEPOSIT</span>
                            </div>
                        </div>
                }
                {HideNavigation == 'true' ? <div></div> :
                    <div className="col-xxl-6 col-md-6 col-sm-6 col-xs-6">
                        <div onClick={() => handleMethodSelect('')} className="box-deposit  othermethod-color mb-4 text-center text-wrap " >
                            <span className="othermethod-text text-center ">USE OTHER DEPOSIT METHODS</span>
                        </div>
                    </div>
                }
            </div>
            <div className="row">
                {arrayPayouts.map((item) => (
                    <div className="col-xxl-4 col-md-4 col-sm-6 col-xs-6">
                        <Link key={item.Key} to={GetFormURL(item.Key)} className="box-deposit  mb-4">
                            <div className="row">
                                <div className="col-md-3 col-sm-12">
                                    <div className="image-wrapper">
                                    <span className="icon-single">
                                        {(item.PaymentType === 'Generic') ?
                                            <img alt="" src={"data:image/svg+xml;base64," + item.ImageName} />
                                            :
                                            <img alt="" src={"/svg/" + item.ImageName + ".svg"} />
                                        }
                                    </span>
                                </div>
                                </div>
                                <div className="col-md-8 col-sm-12 text-center limit-text">
                                    <span>Min:${item.MinPayout === 0 ? 1 : item.MinPayout} - Max:{item.MaxPayout === 0 ? 'No Limit' : '$' + item.MaxPayout}</span>
                                </div>
                                <div className="col-md-3 limit-text d-none d-md-block ">

                                </div>
                            </div>
                        </Link>
                    </div>
                ))}
            </div>
            {HideNavigation == 'true' ? <div></div> :
                <div className="row">
                    <div className="col-12 actionbuttons mt-3">
                        <button type="button" className="btn btn-secondary btn-gray btn-back-order mb-4 " onClick={() => navigate('/deposits/')}>BACK</button>
                    </div>
                </div>
            }
        </div>
    )
}